"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScatterPlotComponent = void 0;
var d3 = require("d3");
var React = require("react");
var react_1 = require("react");
var styles = require("../styles/ChartStyles");
var sizes = require("../util/sizes");
var utils_1 = require("../util/utils");
var DEFAULT_FONT_SIZE = '12px';
var ScatterPlotComponent = function (props) {
    var _a, _b;
    var xAxisLabel = props.xAxisLabel, yAxisLabel = props.yAxisLabel, show45DegreeLine = props.show45DegreeLine, x = props.x, y = props.y, color = props.color, useSameAxisRange = props.useSameAxisRange, legend = props.legend;
    var chartRef = react_1.useRef(null);
    var height = (_a = props.height) !== null && _a !== void 0 ? _a : sizes.heightTall;
    var width = (_b = props.width) !== null && _b !== void 0 ? _b : sizes.widthVeryWide;
    var margin = sizes.chartMargins;
    var chartHeight = height - margin.top - margin.bottom;
    var chartWidth = width - margin.left - margin.right;
    var xAxisTranslate = height - margin.bottom;
    var yAxisTranslate = margin.left;
    // Find min/max for scaling
    var minXValue = Math.min.apply(Math, x);
    var maxXValue = Math.max.apply(Math, x);
    var minYValue = Math.min.apply(Math, y);
    var maxYValue = Math.max.apply(Math, y);
    var maxValue = Math.max(maxXValue, maxYValue);
    var minValue = Math.min(minYValue, minXValue);
    // generate coordinates
    var coordinates = x.map(function (xVal, i) {
        return [xVal, y[i]];
    });
    // Create scales
    var xScale = d3
        .scaleLinear()
        .domain(useSameAxisRange ? [minValue, maxValue] : [Math.round(minXValue), Math.round(maxXValue)])
        .range([margin.left, width - margin.right]);
    var yScale = d3
        .scaleLinear()
        .domain(useSameAxisRange ? [minValue, maxValue] : [Math.round(minYValue), Math.round(maxYValue)])
        .range([height - margin.bottom, margin.top]);
    var drawAxes = react_1.useCallback(function (svg) {
        var yAxis = utils_1.getLinearAxis(yScale, utils_1.AxisPosition.Left);
        utils_1.formatAxis(yAxis, sizes.defaultNumTicks);
        utils_1.drawAxis(svg, yAxis, yAxisTranslate, 0, DEFAULT_FONT_SIZE, styles.barAxisText);
        var xAxis = utils_1.getLinearAxis(xScale, utils_1.AxisPosition.Bottom);
        utils_1.formatAxis(xAxis, sizes.defaultNumTicks, sizes.defaultTickSize, sizes.defaultTickPadding, utils_1.TickFormat.formatK);
        utils_1.drawAxis(svg, xAxis, 0, xAxisTranslate, DEFAULT_FONT_SIZE, styles.barAxisText);
    }, [xAxisTranslate, xScale, yAxisTranslate, yScale]);
    var drawBackgroundGrid = react_1.useCallback(function (svg) {
        var backgroundYAxis = utils_1.getLinearAxis(yScale, utils_1.AxisPosition.Left);
        utils_1.formatAxis(backgroundYAxis, sizes.defaultNumTicks, -chartWidth, sizes.defaultTickPadding, utils_1.TickFormat.hideNumbers);
        utils_1.drawAxisGridLines(svg, backgroundYAxis, yAxisTranslate, 0);
        var backgroundXAxis = utils_1.getLinearAxis(xScale, utils_1.AxisPosition.Bottom);
        utils_1.formatAxis(backgroundXAxis, sizes.defaultNumTicks, -chartWidth, sizes.defaultTickPadding, utils_1.TickFormat.hideNumbers);
        utils_1.drawAxisGridLines(svg, backgroundXAxis, 0, xAxisTranslate);
    }, [chartWidth, xAxisTranslate, xScale, yAxisTranslate, yScale]);
    react_1.useEffect(function () {
        d3.select(chartRef.current).selectAll('*').remove();
        var svg = d3.select(chartRef.current).attr('height', height).attr('width', width);
        var xAxisLabelStartX = chartWidth / 2 + margin.left;
        var xAxisLabelStartY = height;
        utils_1.drawAxisLabel(svg, xAxisLabel || '', xAxisLabelStartX, xAxisLabelStartY, false, DEFAULT_FONT_SIZE, styles.barAxisText);
        var yAxisLabelStartX = 10;
        var yAxisLabelStartY = chartHeight / 2 + margin.top;
        utils_1.drawAxisLabel(svg, yAxisLabel || '', yAxisLabelStartX, yAxisLabelStartY, true, DEFAULT_FONT_SIZE, styles.barAxisText);
        drawAxes(svg);
        drawBackgroundGrid(svg);
        utils_1.drawPoints(svg, coordinates, xScale, yScale, color, 5, 0.5);
        if (show45DegreeLine) {
            utils_1.draw45DegreeLine(svg, xScale, yScale);
        }
    }, [
        chartHeight,
        chartWidth,
        color,
        coordinates,
        drawAxes,
        drawBackgroundGrid,
        height,
        margin,
        show45DegreeLine,
        width,
        xAxisLabel,
        xAxisTranslate,
        xScale,
        yAxisLabel,
        yAxisTranslate,
        yScale,
    ]);
    var renderLegend = function () {
        if (!legend) {
            return null;
        }
        return (React.createElement("div", { className: styles.legend },
            React.createElement("div", { className: styles.legendResult }),
            React.createElement("div", { className: styles.legendText }, legend.result),
            React.createElement("div", { className: styles.legend45DegreeLine }),
            React.createElement("div", { className: styles.legendText }, legend.compareTo)));
    };
    return (React.createElement("div", { className: styles.chartContainer },
        renderLegend(),
        React.createElement("svg", { ref: chartRef })));
};
exports.ScatterPlotComponent = ScatterPlotComponent;
//# sourceMappingURL=ScatterPlotComponent.js.map